var render = function render() {
  var _vm = this,
      _c = _vm._self._c;

  return _c('el-input', _vm._g(_vm._b({}, 'el-input', _vm.$attrs, false), _vm.$listeners), [_vm.$attrs.append ? _c('template', {
    slot: "append"
  }, [_vm._v(" " + _vm._s(_vm.$attrs.append) + " ")]) : _vm._e(), _vm.$attrs.prepend ? _c('template', {
    slot: "prepend"
  }, [_vm._v(" " + _vm._s(_vm.$attrs.prepend) + " ")]) : _vm._e()], 2);
};

var staticRenderFns = [];
export { render, staticRenderFns };